import React from 'react';
import { Link } from 'react-router-dom';
interface MatchCardProps {
  id: string;
  name: string;
  sub: string;
  desc: string;
  matchScore: number;
  status?: string;
  view: 'brand' | 'organizer';
}
export function MatchCard({
  id,
  name,
  sub,
  desc,
  matchScore,
  status,
  view
}: MatchCardProps) {
  return <div className="flex flex-col sm:flex-row sm:items-center justify-between p-3 rounded-xl border border-gray-100 hover:border-violet-100 hover:bg-violet-50/30 transition-colors gap-4 sm:gap-0" data-id="element-304">
      <div className="flex items-center gap-3" data-id="element-305">
        <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-violet-500 to-purple-400 text-white flex items-center justify-center font-semibold text-lg shrink-0" data-id="element-306">
          {name.substring(0, 2).toUpperCase()}
        </div>
        <div data-id="element-307">
          <div className="text-sm font-semibold text-gray-900" data-id="element-308">{name}</div>
          <div className="text-xs text-gray-500" data-id="element-309">{sub}</div>
          <div className="text-xs text-gray-400 mt-1 line-clamp-1" data-id="element-310">{desc}</div>
        </div>
      </div>

      <div className="flex items-center gap-4 self-end sm:self-auto" data-id="element-311">
        <div className={`text-sm font-semibold ${matchScore >= 80 ? 'text-green-600' : matchScore >= 60 ? 'text-yellow-600' : 'text-gray-600'}`} data-id="element-312">
          {matchScore}%
        </div>
        <Link to={`/dashboard/${view}/matches/${id}`} className="px-3 py-1 rounded-md bg-white border text-sm text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-313">
          View
        </Link>
        <button className="px-3 py-1 rounded-md bg-violet-600 text-white text-sm hover:bg-violet-700 transition-colors" data-id="element-314">
          Connect
        </button>
      </div>
    </div>;
}